export const resources_nodes = {
  en: {
    translation: {
      Noeud: {
        // ❌ SUPPRIMÉ : Nom (maintenant dans ELEMENTS_SELECTION_CONFIG)
        // ❌ SUPPRIMÉ : TS (maintenant dans ELEMENTS_SELECTION_CONFIG)
        // ❌ SUPPRIMÉ : NS (maintenant dans ELEMENTS_SELECTION_CONFIG)

        Style: 'Stylesheet',
        OrderStyle: 'Order of styles associated',
        multi_style: 'Selected nodes have different style',
        editStyle: 'Assign a style',
        AS: 'Reset',
        SelectStyle: 'Select a style',
        Reorg: 'Reorganize incoming/outgoing links',
        Reorg_title: 'Reorganization',
        Slct: 'Selection',
        SlctOutLink: 'Select outgoing links',
        SlctInLink: 'Select incoming links',
        SlctL: 'Sélectionner les flux',
        SlctOL: 'Output',
        SlctIL: 'Input',
        IB: 'Tooltip',
        IS: 'Additional info.',
        align_horiz: 'Horizontally',
        align_horiz_min: 'Relative to the selected node furthest to the left',
        align_horiz_max: 'Relative to the selected node furthest to the right',
        align_vert: 'Vertically',
        align_vert_min: 'Relative to the selected topmost node',
        align_vert_max: 'Relative to the selected node furthest down',
        align_horiz_left: 'Align to its left',
        align_horiz_center: 'Align to its center',
        align_horiz_right: 'Align to its right',
        align_vert_top: 'Align to its top',
        align_vert_bottom: 'Align to its bottom',
        align: 'Align nodes',
        product: 'Product',
        sector: 'Sector',
        exchange: 'Exchange',
        size: 'Size',
        position: 'Position',
        text: 'Text',
        selector: 'Select nodes',
        title_desaggreg: 'Dimension disagregation',
        title_aggreg: 'Dimension agregation',
        text_agreg: 'Will agregate in : ',
        text_desagreg: 'Will disagregate in : ',
        desaggreg: 'Disagregation',
        aggreg: 'Agregation',
        firstPlan: 'Move in the bakground',
        lastPlan: 'Move at the foreground',
        changePlan: 'Change plan of nodes',
        mask_attr: 'Elements display',
        tooltips: {
          // ❌ SUPPRIMÉ : Nom (maintenant dans ELEMENTS_SELECTION_CONFIG as tooltips.Nom)
          AS: 'Allow to apply a predefined style in the preference menu to the selected node(s)',
          Reorg: 'Allows automatic reorganization of incoming and outgoing links (up/down position)',
          SlctOutLink: 'Allow to select all outgoing links from the node(s)',
          SlctInLink: 'Allow to select all incoming links to the node(s)',
          IB: 'Tooltip : text formatted in HTML and displayed with the tooltip of the node. This tooltip pops on graphic space with SHIFT + MOUSE on the node.',
        },
        drawing_area_tooltip: {
          outputs: 'Outputs',
          inputs: 'Inputs',
          dest: 'Outputs',
          val: 'Values',
          data_value: 'Collected data',
          result_value: 'Computed data',
          rat: 'Ratios',
          prov: 'Inputs',
          values_tab: 'Values',
          tags_tab: 'Other informations'
        },
        tabs: {
          apparence: 'Appearence',
          infos: 'Additional info.',
          tags: 'Tags',
          io: 'I/O links positions',
        },
        apparence: {
          apparence: 'Appearence',
          shape_visible: 'Shape',
          shape_color: 'Color',
          shape_color_sustainable: 'Static color',
          shape_type: 'Shape of node',
          Geometry: 'Geometry',
          Cercle: 'Arc',
          Rectangle: 'Rectangle',
          shape_min_width: 'Minimum width',
          shape_min_height: 'Minimum height',
          geometry: 'Positioning',
          geometry_absolute: 'Absolute',
          geometry_parametric: 'Spacing',
          geometry_relative: 'Offset',
          position_u: 'Colonne',
          column_u: 'Column (u)',
          position_v: 'Row',
          row_v: 'Row (v)',
          position_dx: 'Ecart horizontal',
          position_dy: 'Ecart vertical',
          asn: 'Apply style to nodes',
          override_type_node_shape: 'Override default shape',
          arrow: 'Arrow',
          display_shape: 'Display the node shape',
          hide_shape: 'Hide the node shape',
          display_label: 'Display the label',
          hide_label: 'Hide the label',
          display_value: 'Display the value',
          hide_value: 'Hide the value',
          shape_opacity: 'Opacity',
          tooltips: {
            FormeDisabled: 'Deactivated because the shape is managed by the "Type de noeud" tag group, if you want to be able to change the shape of the selected nodes, go to the "tags" tab and uncheck all the selected tag of the "Type de noeud" group',
            geometry: 'Méthode pour calculer la position du noeud. Cette position peut être donnée en coordonnées absolues x,y, en coordonnée relative u,v, ou en coordonnée relative à une autre noeud.',
            position_dx: 'Ecart horizontal entre le bord droit du noeud à gauche et le bord gauche du noeud',
            position_dy: 'Ecart vertical entre le bord inférieur du noeud au dessus et le bord supérieur du noeud',
            shape_position_u_locked: 'When locked, autosankey compute keeps this node\'s column index (u) instead of recomputing it.',
            shape_position_v_locked: 'When locked, autosankey compute preserves the relative vertical order (v) of this node within its column instead of recomputing it.',
            override_type_node_shape: 'Override the default forced shape of product and sector type nodes',
          }
        },
        node_value: {
          anchor: 'Anchor position',
          anchor_dx: 'Horizontal shift',
          anchor_dy: 'Vertical shift',
          tooltips: {
            anchor: 'The anchor of node value can be positioned by combining horizontal position : left, middle and right; and vertically : top, middle and bottom',
            anchor_dx: 'Horizontal shift from label anchor',
            anchor_dy: 'Vertical shift from label anchor',
          }
        },
        labels: {
          labels: 'Name',
          node_value: 'Value',
          name_label_is_visible: 'Label',
          lb: 'White label',
          name_label_background: 'Background',
          name_label_background_color: 'Background color',
          pos: 'Position',
          pos_v: 'Value position',
          tp: 'Font size',
          cl: 'Text box width',
          vdv: 'Value',
          edit_node_label: 'Edit node label',
          anchor: 'Anchor position',

          tooltips: {
            name_label_is_visible: 'Displays or not the label(s) attached to the selected node(s)',
            lb: 'Displays the text of the label(s) in white or black (useful if label is positioned on node(s))',
            name_label_background: 'Add a background to the label for a better visibility in case the label is in front of a link',
            top: 'Displays the label(s) above the selected node(s)',
            Milieu_pv: 'Displays the label(s) in the middle (vertically) of the selected node(s)',
            Bas: 'Displays the label(s) below the selected node(s)',
            gauche: 'Displays the label(s) to the left of the selected node(s)',
            Milieu_ph: 'Displays the label(s) in the middle (horizontally) of the selected node(s)',
            droite: 'Displays the label(s) to the right of the selected node(s)',
            cl: 'Width of the text area (in pixels) for the label(s) of the selected node(s)',
            vdv: 'Displays or not the associated value with the selected node(s)',
            anchor: 'L\'ancre du label peut être positionné de 9 manières par rapport à la forme combinant horizontalement bord gauche, milieu bord droit et verticalement bord supérieur milieu bord inférieur',
            haut_val: 'Displays the associated value above the selected node(s)',
            Milieu_pv_val: 'Displays the associated value in the middle (vertically) of the selected node(s)',
            Bas_val: 'Displays the associated value below the selected node(s)',
            gauche_val: 'Displays the associated value to the left of the selected node(s)',
            Milieu_ph_val: 'Displays the associated value in the middle (horizontally) of the selected node(s)',
            droite_val: 'Displays the associated value to the right of the selected node(s)',
          }
        },
        tags_node: {
          tags: 'Tags',
          Appartenance: 'Affiliations'
        },
        agre: {
          Agré: 'Aggregation',
          DC: 'Cube\'s dimensions',
          Parent: 'Parent',
          CLE: 'Copy childs\' links'
        },
        PF: {
          PF: 'I/O links positions',
          PFM: 'I/O links positions',
          FES: 'Links type',
          ent: 'Input',
          sort: 'Output',
          FRN: 'Relative position / node',
          gauche: 'Left',
          droite: 'Right',
          ades: 'Above',
          edes: 'Below',
          lti: 'Identify the links in the table with their colors',
          col: 'Apply',
          filter_links: 'Links to display',
          visible_links: 'Visible links',
          all_links: 'All links',
          tooltips: {
            io: 'Choose either the incoming or outgoing links of the selected node',
            side: 'Choose either the right, left, top or bottom links of the selected node',
            lti: 'Display the lines of the links table with their respective colors to better identify them',
            filter_links: 'Show only visible links or all links including hidden ones'
          }
        }
      },
      ElementStyle: {
        NodeStyle: 'Default node style',
        LinkStyle: 'Default link style',
        ContainerStyle: 'Default container style',
        NodeProductStyle: 'Product label style',
        NodeSectorStyle: 'Sector label style',
        NodeImportExportCloseStyle: 'Node import-export attached',
        NodeImportCloseStyle: 'Node import attached',
        NodeExportCloseStyle: 'Node export attached',
        NodeImportExportAboveBelowStyle: 'Node import-export above/below',
        NodeImportAboveStyle: 'Node import above',
        NodeExportBelowStyle: 'Node export below',
        LinkImportExportCloseStyle: 'Link import-export attached',
        LinkImportCloseStyle: 'Link import attached',
        LinkExportCloseStyle: 'Link export attached',
        LinkImportExportAboveBelowStyle: 'Link import-export above/below',
        SankeyUnitaryNodeStyle: 'Unitary node',
        SankeyUnitaryNodeInputStyle: 'Unitary node input',
        SankeyUnitaryNodeOutputStyle: 'Unitary node output',
        LinkInUnitaryStyle: 'Unitary input link',
        LinkOutUnitaryStyle: 'Unitary output link'
      }
    }
  },
  fr: {
    translation: {
      Noeud: {
        // ❌ SUPPRIMÉ : Nom (maintenant dans ELEMENTS_SELECTION_CONFIG)
        // ❌ SUPPRIMÉ : TS (maintenant dans ELEMENTS_SELECTION_CONFIG)
        // ❌ SUPPRIMÉ : NS (maintenant dans ELEMENTS_SELECTION_CONFIG)

        Style: 'Feuille de style',
        OrderStyle: 'Ordre des styles associés',
        editStyle: 'Assigner un style',
        multi_style: 'Multiple style sélectionné',
        SelectStyle: 'Sélectionner un style',
        AS: 'Réinitialiser',
        Reorg: 'Réorganiser automatiquement les flux E/S',
        Reorg_title: 'Ordre des flux E/S',
        Slct: 'Sélection',
        SlctOutLink: 'Sélectionner flux sortants',
        SlctInLink: 'Sélectionner flux entrants',
        SlctL: 'Sélectionner les flux',
        SlctOL: 'Sortants',
        SlctIL: 'Entrants',
        IB: 'Info-bulle',
        IS: 'Info sup.',
        align_horiz: 'Horizontalement',
        align_horiz_min: 'Par rapport au noeud sélectionné le + à gauche',
        align_horiz_max: 'Par rapport au noeud sélectionné le + à droite',
        align_vert: 'Verticalement',
        align_vert_min: 'Par rapport au noeud sélectionné le + en haut',
        align_vert_max: 'Par rapport au noeud sélectionné le + en bas',
        align_horiz_left: 'À son côté gauche',
        align_horiz_center: 'À son centre',
        align_horiz_right: 'À son côté droit',
        align_vert_top: 'À son côté du dessus',
        align_vert_bottom: 'À son côté du dessous',
        align: 'Aligner les noeuds',
        product: 'Produit',
        sector: 'Secteur',
        exchange: 'Échange',
        selector: 'Selectionner des noeuds',
        size: 'Taille',
        position: 'Position',
        text: 'Texte',
        title_desaggreg: 'Dimension desagrégation',
        title_aggreg: 'Dimension agrégation',
        text_agreg: 'Sera aggrégé en : ',
        text_desagreg: 'Sera désaggrégé en : ',
        desaggreg: 'Désagrégation',
        aggreg: 'Agrégation',
        firstPlan: 'Mettre au dernier plan',
        lastPlan: 'Mettre au premier plan',
        changePlan: 'Modifier le plan des noeud',
        mask_attr: 'Affichage des éléments',
        tooltips: {
          // ❌ SUPPRIMÉ : Nom (maintenant dans ELEMENTS_SELECTION_CONFIG as tooltips.Nom)
          AS: 'Permettre d\'appliquer un style prédéfini dans le menu préférence au(x) noeud(s) selectionné(s)',
          Reorg: 'Permet de réorganiser automatiquement les flux entrant et sortant (position haut / bas)',
          SlctOutLink: 'Permettre de sélectionner tous les flux sortants du/des noeud(s)',
          SlctInLink: 'Permettre de sélectionner tous les flux entrants vers le/les noeud(s)',
          IB: 'Info bulle : texte formaté en HTML et affiché avec l\'info-bulle du noeud. Cet info-bulle apparait sur espace graphique avec SHIFT + SOURIS sur le noeud',
        },
        drawing_area_tooltip: {
          outputs: 'Sorties',
          inputs: 'Entrées',
          val: 'Valeurs',
          data_value: 'Donnée collectée',
          result_value: 'Donnée calculée',
          rat: 'Ratios',
          prov: 'Entrées',
          dest: 'Sorties',
          values_tab: 'Valeurs',
          tags_tab: 'Autres informations'
        },
        tabs: {
          apparence: 'Apparence',
          infos: 'Info sup.',
          tags: 'Étiquettes',
          io: 'Flux E/S',
        },
        apparence: {
          apparence: 'Apparence',
          Geometry: 'Géométrie',
          Cercle: 'Cercle',
          Rectangle: 'Rectangle',
          geometry: 'Positionnement',
          geometry_absolute: 'Absolu',
          geometry_relative: 'Décalage',
          geometry_parametric: 'Ecartement',
          position_u: 'Colonne',
          column_u: 'Colonne (u)',
          position_v: 'Ligne',
          row_v: 'Ligne (v)',
          position_dx: 'Ecart horizontal',
          position_dy: 'Ecart vertical',
          asn: 'Appliquer le style aux noeuds',
          override_type_node_shape: 'Déverrouiller la forme',
          arrow: 'Flèche',
          shape_arrow_angle_factor: 'Inclinaison flèche',
          shape_arrow_angle_direction: 'Orientation flèche',
          display_shape: 'Afficher le noeud',
          hide_shape: 'Masquer le noeud',
          display_label: 'Afficher le nom',
          hide_label: 'Masquer le nom',
          display_value: 'Afficher la valeur',
          hide_value: 'Masquer la valeur',
          tooltips: {
            FormeDisabled: 'Désactivé car la forme est gérée par le groupe d\'étiquette "Type de noeud", si vous voulez pouvoir modifier la forme des noeuds séléctionnés, allez dans l\'onlget Étiquettes et décochez tous les étiquettes sélectionné du groupe "Type de noeud"',
            geometry: 'Méthode pour calculer la position du noeud. Cette position peut être donnée en coordonnées absolues x,y, en coordonnée relative u,v, ou en coordonnée relative à une autre noeud.',
            position_dx: 'Ecart horizontal entre le bord droit du noeud à gauche et le bord gauche du noeud',
            position_dy: 'Ecart vertical entre le bord inférieur du noeud au dessus et le bord supérieur du noeud',
            shape_position_u_locked: 'Si verrouillé, le calcul autosankey conserve l\'index de colonne (u) de ce nœud au lieu de le recalculer.',
            shape_position_v_locked: 'Si verrouillé, le calcul autosankey conserve l\'ordre vertical relatif (v) de ce nœud dans sa colonne au lieu de le recalculer.',
            override_type_node_shape: 'Permet de changer la forme forcée par défaut sur les noeuds de types produits et secteur',
          }
        },
        node_value: {
          anchor: 'Position de l\'ancre',
          anchor_dx: 'Décalage horizontal',
          anchor_dy: 'Décalage vertical',
          tooltips: {
            anchor: 'L\'ancre de la valeur du noeud peut être positionné de 9 manières par rapport à la forme combinant horizontalement bord gauche, milieu bord droit et verticalement bord supérieur milieu bord inférieur',
            anchor_dx: 'Décalage horizontal par rapport à l\'ancre de la valeur du noeud',
            anchor_dy: 'Décalage vertical par rapport à l\'ancre e la valeur du noeud',
          }
        },
        labels: {
          labels: 'Nom',
          node_value: 'Valeur',
          name_label_is_visible: 'Libellé',
          lb: 'Blanc',
          name_label_background: 'Fond',
          name_label_background_color: 'Couleur fond',
          pos: 'Position',
          pos_v: 'Position de la valeur',
          tp: 'Taille de police',
          cl: 'Largeur zone de texte',
          vdv: 'Valeur',
          edit_node_label: 'Éditer le nom',
          anchor: 'Position de l\'ancre',
          tooltips: {
            lb: 'Permet d\'afficher le texte du label en blanc ou en noir (utile si label positionné sur noeud(s))',
            haut: 'Positionner le label au dessus du/des noeud(s) sélectionné(s)',
            Milieu_pv: 'Positionner le label au milieu (verticalement) du/des noeud(s) sélectionné(s)',
            Bas: 'Positionner le label en dessous du/des noeud(s) sélectionné(s)',
            gauche: 'Positionner le label à gauche du/des noeud(s) sélectionné(s)',
            Milieu_ph: 'Positionner le label au milieu (horizontalement) du/des noeud(s) sélectionné(s)',
            droite: 'Positionner le label à droite du/des noeud(s) sélectionné(s)',
            cl: 'Largeur de la zone de texte (en pixel) pour le label du/des noeud(s) sélectionné(s)',
            vdv: 'Active l\'affichage de la valeur associée au(x) noeud(s) sélectionné(s)',
            anchor: 'L\'ancre du label peut être positionné de 9 manières par rapport à la forme combinant horizontalement bord gauche, milieu bord droit et verticalement bord supérieur milieu bord inférieur',
            haut_val: 'Positionner l\'affichage de la valeur associée au dessus du/des noeud(s) sélectionné(s)',
            Milieu_pv_val: 'Positionner l\'affichage de la valeur associée au milieu (verticalement) du/des noeud(s) sélectionné(s)',
            Bas_val: 'Positionner l\'affichage de la valeur associée en dessous du/des noeud(s) sélectionné(s)',
            gauche_val: 'Positionner l\'affichage de la valeur associée à gauche du/des noeud(s) sélectionné(s)',
            Milieu_ph_val: 'Positionner l\'affichage de la valeur associée au milieu (horizontalement) du/des noeud(s) sélectionné(s)',
            droite_val: 'Positionner l\'affichage de la valeur associée à droite du/des noeud(s) sélectionné(s)',
          }
        },
        tags_node: {
          tags: 'Étiquettes',
          Appartenance: 'Appartenance'
        },
        agre: {
          Agré: 'Agrégations',
          DC: 'Dimension du cube',
          Parent: 'Parent',
          CLE: 'Copier liens enfants'
        },
        PF: {
          PF: 'Flux E/S',
          PFM: 'Organiser flux E/S',
          FES: 'Type de flux',
          ent: 'Entrant',
          sort: 'Sortant',
          FRN: 'Position / noeud',
          gauche: 'Gauche',
          droite: 'Droite',
          ades: 'Au-dessus',
          edes: 'En-dessous',
          lti: 'Identifier les flux du tableau avec leurs couleurs',
          col: 'Appliquer',
          filter_links: 'Flux à afficher',
          visible_links: 'Flux visibles',
          all_links: 'Tous les flux',
          tooltips: {
            io: 'Choisir les flux entrants ou sortant du noeud selectionné',
            side: 'Choisir les flux de droite, gauche, bas ou haut du noeud selectionné',
            lti: 'Affiche les lignes du tableau des flux avec leur couleurs respectives pour mieux les identifier',
            filter_links: 'Afficher uniquement les flux visibles ou tous les flux y compris les masqués'
          }
        }
      },
      ElementStyle: {
        NodeStyle: 'Style de noeud par défaut',
        LinkStyle: 'Style de flux par défaut',
        ContainerStyle: 'Style de container par défaut',
        NodeProductStyle: 'Style étiquette produit',
        NodeSectorStyle: 'Style étiquette secteur',
        NodeImportExportCloseStyle: 'Noeud import export collé',
        NodeImportCloseStyle: 'Noeud import collé',
        NodeExportCloseStyle: 'Noeud export collé',
        NodeImportExportAboveBelowStyle: 'Noeud import export dessus/dessous',
        NodeImportAboveStyle: 'Noeud import au dessus',
        NodeExportBelowStyle: 'Noeud export au dessous',
        LinkImportExportCloseStyle: 'Flux import export collé',
        LinkImportCloseStyle: 'Flux import collé',
        LinkExportCloseStyle: 'Flux export collé',
        LinkImportExportAboveBelowStyle: 'Flux import export haut/bas',
        SankeyUnitaryNodeStyle: 'Unitaire noeud',
        SankeyUnitaryNodeInputStyle: 'Unitaire noeud entrée',
        SankeyUnitaryNodeOutputStyle: 'Unitaire noeud sortie',
        LinkInUnitaryStyle: 'Unitaire flux entrée',
        LinkOutUnitaryStyle: 'Unitaire flux sortie'
      }
    }
  }
}